import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'do_trade_union_representatives_have_time_off_to_attend_relevant'

export const dataPointDefinition = {
  retracedId: 'do_trade_union_representatives_have_time_off_to_attend_relevant',
  name: 'Do Trade Union representatives have time off to attend relevant trainings or meetings outside the factory?',
  description:
    'The intent of this question is to understand if the union representative can perform their responsibility properly.\r\r\n\r\r\nIf there was no union presence in the facility during the assessment period, answer Not applicable. ',
  meta: {},
  fieldTypeId: 'SELECT',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'ynna',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'ynna',
    },
    {
      name: 'Not Applicable',
      key: 'NOT_APPLICABLE',
      slcpIndex: 3,
      slcpOptionName: 'ynna',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO', 'NOT_APPLICABLE'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wi-foa-72',
      version: '1.6.0',
      provider: 'slcp',
    },
  ],
  sortingId: 12300,
  sectionId: '2.2.8',
  impactArea: 'Freedom of Association and Collective Bargaining',
  impactAreaId: 'FREEDOM_OF_ASSOCIATION_AND_COLLECTIVE_BARGAINING',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
